import * as React from "react";
import Drawer from "@mui/material/Drawer";
import { ProjectLogs } from "./ProjectLogs";
import { useDispatch } from "react-redux";
// import {
//   getBatchDocuments,
//   getBatchOrProjectLogs,
//   getBatchParameters,
// } from "../../../redux/investigation/actions";

const LogDrawer = ({
  anchor,
  openLogDialog,
  closeLogDrawer,
  selectedDetails,
  role,
}) => {
  const dispatch = useDispatch;

  return (
    <div>
      <React.Fragment key={anchor}>
        <Drawer
          anchor={"right"}
          open={openLogDialog}
          onClose={() => closeLogDrawer()}
          sx={{ "& .MuiDrawer-paper": { width: 650 } }}
        >
          <ProjectLogs
            selectedDetails={selectedDetails}
            role={role}
            closeLogDrawer={closeLogDrawer}
          />
        </Drawer>
      </React.Fragment>
    </div>
  );
};

export default LogDrawer;
